let productTileMarkup = `
	<div class="swym-wishlist-items">
	    <div class="wishlist__overlay" onclick="event.stopPropagation();closePopup(this);"></div>
	    {{#products}} 
	    <div class="swym-wishlist-item">
            <div class="swym-product-card">
                <a href="#" class="swym-item__wishlist-btn" data-product-id="{{empi}}" data-variant-id="{{epi}}" data-product-url="{{du}}">
                    <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 0H4.40557V0.482063V7.51464L0.5 10V0Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.31113 0H4.40557V0.482063V7.51464L8.31113 10V0Z" fill="black"/>
                    </svg>
                </a>
                
                <div class="swym-item__image js">
                    <div class="wrapper">
                        <img class="image lazyautosizes" src="{{iu}}" loading="lazy" />
                    </div>
                    <div class="variant-slider"></div>
                </div>
                
                <a class="swym-item__link" href="{{du}}">
                    <div class="swym-item__title rocket-font-helvetica" aria-hidden="true">{{dt}}</div>
                </a>
    
                <div class="price rocket-font-helvetica" data-price="">
                    <span class="price-item price-item--sale" data-sale-price="">
                          {{pr}}{{cu}}
                    </span>
                </div>
            </div>
            <script type="application/json" product-wishlist-variants>{{cpropsData}}</script>
        </div>
        {{/products}}
    </div>
    `;

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function fetchedLists() {
  return new Promise((resolve, reject) => {
    let lids = [];
    let onSuccess = function (lists) {
      console.log("Fetched all Lists", lists);

      lists.forEach(function (list) {
        lids.push(list.lid);
      });

      resolve(lids); // Resolve the promise with the lids array
    };

    let onError = function (error) {
      console.log("Error while fetching all Lists", error);
      reject(error); // Reject the promise with the error
    };

    window._swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError,
    });
  });
}

function swymRenderWishlist(swat) {
  let wishlistContentsContainer = document.getElementById(
    "rocket-wishlist-items"
  );
  let onSuccess = function (lists) {
    let formattedWishlistedProducts = "";
    let lids = [];
    // console.log(lists);
    lists.forEach(function (list) {
      lids.push(list.lid);
      fetchCallbackFn(list.listcontents);

      formattedWishlistedProducts = list.listcontents.map(function (p) {
        p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
        p.isInCart =
          _swat.platform.isInDeviceCart(p.epi) ||
          p.et == _swat.EventTypes.addToCart;
        p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";

        if (p.cu == "₫") {
          p.pr = Math.trunc(parseInt(p.pr));
        }

        if (p.hasOwnProperty("cprops")) {
          p.cpropsData = p.cprops.variants;
        }

        return p;
      });
    });

    setCookie("idWishList", lids);

    var productTilesMarkup = SwymUtils.renderTemplateString(productTileMarkup, {
      products: formattedWishlistedProducts,
    });

    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productTilesMarkup;
      attachClickListeners();
      initVariantPicker();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  };
  let onError = function (error) {
    console.log("Error while fetching all Lists", error);
  };

  // Get wishlist items
  window._swat.fetchLists({
    callbackFn: onSuccess,
    errorFn: onError,
  });
}

function createListWishList(idListName = null) {
  return new Promise((resolve, reject) => {
    let listConfig = {};

    if (idListName) {
      listConfig = {
        lname: idListName,
      };
    } else {
      listConfig = {
        lname: randomString(20),
      };
    }

    let onSuccess = function (newList) {
      console.log("Successfully created a new List", newList);

      let lids = [];
      lids.push(newList.lid);

      setCookie("idWishList", lids);
      resolve(getIdWishList());
    };

    let onError = function (error) {
      console.log("Error while creating a List", error);
      reject(error);
    };

    window._swat.createList(listConfig, onSuccess, onError);
  });
}

function getListWishListDetail() {
  let lid = getIdWishList();

  if (lid) {
    let listConfig = {
      lid: lid,
    };
    let onSuccess = function (listDetails) {
      console.log("Successfully fetched List details", listDetails);
    };
    let onError = function (error) {
      console.log("Error while fetching List details", error);
    };

    window._swat.fetchListDetails(listConfig, onSuccess, onError);
  }
}

function attachClickListeners() {
  var removeBtns = document.querySelectorAll(".swym-item__wishlist-btn");

  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

function onRemoveBtnClick(e) {
  e.preventDefault();

  let lids = getIdWishList();
  console.log(lids);
  if (!lids) {
    $.notify(locales[Shopify.locale].remove_from_list.error, "error");
    return;
  }

  let product = {
    empi: e.currentTarget.getAttribute("data-product-id"),
    epi: e.currentTarget.getAttribute("data-variant-id"),
    du: e.currentTarget.getAttribute("data-product-url"),
  };

  let onSuccess = function (deletedProduct) {
    // console.log("Successfully deleted the product from list", deletedProduct);
    $.notify(locales[Shopify.locale].remove_from_list.success, "success");

    window.SwymCallbacks.push(swymRenderWishlist);
  };
  let onError = function (error) {
    // console.log("Error while deleting the product", error);
    $.notify(locales[Shopify.locale].remove_from_list.error, "error");

    window.SwymCallbacks.push(swymRenderWishlist);
  };

  window._swat.removeProductFromLists(product, lids, onSuccess, onError);
}

function fetchCallbackFn(products) {
  let productMain = document.querySelector(
    ".rocket-scalpers-main-product__save"
  );

  if (productMain) {
    let mainProductId = productMain
      .querySelector(".add")
      .getAttribute("data-product-id");
    let mainVariantId = productMain
      .querySelector(".add")
      .getAttribute("data-variant-id");

    var inWishlist = products.find(function (p) {
      return p.empi == mainProductId && p.epi == mainVariantId;
    });

    if (inWishlist) {
      var childElm = productMain.querySelector(".add");
      changeStatusWishlist(childElm, true);
    } else {
      var childElm = productMain.querySelector(".remove");
      changeStatusWishlist(childElm, false);
    }
  }

  let productsCard = document.querySelectorAll(
    ".rocket-scalpers-product-card__save"
  );

  productsCard &&
    productsCard.forEach(function (elm) {
      let cardProductId = elm
        .querySelector(".add")
        .getAttribute("data-product-id");
      let cardVariantId = elm
        .querySelector(".add")
        .getAttribute("data-variant-id");

      var inWishlist = products.find(function (p) {
        return p.empi == cardProductId && p.epi == cardVariantId;
      });

      if (inWishlist) {
        var childElm = elm.querySelector(".add");
        changeStatusWishlist(childElm, true);
      } else {
        var childElm = elm.querySelector(".remove");
        changeStatusWishlist(childElm, false);
      }
    });
}

function randomString(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

function getIdWishList() {
  idWishListString = getCookie("idWishList");
  idsWishList = idWishListString.split(",");

  return idsWishList;
}

function addOrDeleteProductToWishList(elm, type) {
  let lid, customerId;

  (async () => {
    try {
      let lids = await fetchedLists();

      if (lids.length == 0) {
        customerId = ShopifyAnalytics.meta.page.customerId;

        if (customerId) {
          lids = await createListWishList(customerId);
        } else {
          lids = await createListWishList();
        }
      }

      if (lids) {
        if (type == "add") {
          let onSuccess = function (addedListItem) {
            // console.log(`Successfully added the Product to List with lid ${lid}`, addedListItem);
            $.notify(locales[Shopify.locale].add_to_list.success, "success");

            window.SwymCallbacks.push(swymRenderWishlist);
          };
          let onError = function (error) {
            // console.log("Error while adding the Product to the List", error);
            $.notify(locales[Shopify.locale].add_to_list.error, "error");

            window.SwymCallbacks.push(swymRenderWishlist);
          };

          let variants = elm.querySelector(
            "script[product-variant-data]"
          ).textContent;

          let product = {
            empi: elm.getAttribute("data-product-id"),
            epi: elm.getAttribute("data-variant-id"),
            du: "https://" + elm.getAttribute("data-product-url"),
            cprops: { variants },
            pr: elm.getAttribute("data-price").replace(/,/g, ""),
            et: 4,
          };

          console.log(product);

          changeStatusWishlist(elm, true);
          window._swat.addProductToLists(product, lids, onSuccess, onError);
        } else {
          let onSuccess = function (addedListItem) {
            // console.log(`Successfully remove the Product from List with lid ${lid}`, addedListItem);
            $.notify(
              locales[Shopify.locale].remove_from_list.success,
              "success"
            );

            window.SwymCallbacks.push(swymRenderWishlist);
          };
          let onError = function (error) {
            // console.log("Error while remove the Product from List", error);
            $.notify(locales[Shopify.locale].remove_from_list.error, "error");

            window.SwymCallbacks.push(swymRenderWishlist);
          };

          let product = {
            empi: elm.getAttribute("data-product-id"),
            epi: elm.getAttribute("data-variant-id"),
            du: "https://" + elm.getAttribute("data-product-url"),
          };

          changeStatusWishlist(elm, false);
          window._swat.removeProductFromLists(
            product,
            lids,
            onSuccess,
            onError
          );
        }
      }
    } catch (error) {
      console.error("Error while fetching lists", error);
    }
  })();
}

function changeStatusWishlist(elm, status) {
  if (status) {
    elm.classList.add("hidden");
    elm.nextElementSibling.classList.remove("hidden");
  } else {
    elm.classList.add("hidden");
    elm.previousElementSibling.classList.remove("hidden");
  }
}

function initVariantPicker() {
  let wishlistContainer = document.querySelector("#rocket-wishlist-items");
  checkEmptyWishlist();
  if (!wishlistContainer.querySelector("variant-swiper")) {
    let wishlistItems = document.querySelectorAll(".swym-wishlist-item");
    wishlistItems &&
      wishlistItems.forEach(function (item) {
        prepareVariantsData(item);
      });
  }
}

function checkEmptyWishlist() {
  let wishlistItems = document.querySelectorAll(
    "#rocket-wishlist-items .swym-wishlist-item"
  );
  if (wishlistItems.length == 0) {
    document
      .querySelector(".wishlist-empty")
      ?.classList.remove("visually-hidden");
  } else {
    document.querySelector(".wishlist-empty")?.classList.add("visually-hidden");
  }
}

function prepareVariantsData(product) {
  if (product.length === 0) {
    console.log("wishlist empty!");
    return;
  }

  let variantsData = JSON.stringify(
    product.querySelector("script[product-wishlist-variants]").textContent
  );
  let parseData = JSON.parse(variantsData)
    .replace(/&quot;/g, '"')
    .replace(/&#x2F;/g, "/");
  let variantObjects = JSON.parse(parseData);
  var sizeKey = "option1";
  if (
    variantObjects[0].option2 &&
    variantObjects[0].option1.length > variantObjects[0].option2.length
  ) {
    sizeKey = "option2";
  }

  const variantSizes = variantObjects.filter(
    (value, index, self) =>
      self.findIndex((m) => m[sizeKey] === value[sizeKey]) === index
  );

  createVariantSwiper(product, variantSizes);
}

function createVariantSwiper(product, variantSizes) {
  if (!Array.isArray(variantSizes) || variantSizes.length === 0) {
    return;
  }
  let productId = product
    .querySelector(".swym-item__wishlist-btn")
    .getAttribute("data-product-id");
  let productUrl = product
    .querySelector(".swym-item__wishlist-btn")
    .getAttribute("data-product-url");

  let swiperWrapper = document.createElement("fieldset");
  swiperWrapper.classList.add("product-form__input", "swiper-wrapper");

  variantSizes.forEach(function (variant) {
    let item = createSwiperItem(variant, productId, productUrl);
    swiperWrapper.insertAdjacentHTML("beforeend", item);
  });

  if (swiperWrapper.length !== 0) {
    let swiper = createVariantSwiperTemplate(swiperWrapper, productId);
    let productSlider = product.querySelector(".variant-slider");

    let mbBtn = `<div onclick="event.stopPropagation();openPopup(this);" class="wishlist-open-cart-mb">
                             <svg class="wishlist-open-cart-mb--icon" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.4077 9.5V5.33395H0.25V4.64935H4.4077V0.5H5.0756V4.64935H9.25V5.33395H5.0756V9.5H4.4077Z" fill="#191919"/>
                             </svg>
                         </div>`;

    product
      .querySelector(".swym-item__image")
      .insertAdjacentHTML("beforeend", mbBtn);
    productSlider.insertAdjacentHTML("beforeend", swiper);
  }
}

function createVariantSwiperTemplate(swiperWrapper, productId) {
  let swiperTemplate = `
                    <div onclick="event.stopPropagation();return false;" class="wishlist__size-heading-wrapper">
                        <div class="wishlist__size-close-wrapper">
                            <div onclick="event.stopPropagation();closePopup(this);" class="wishlist__size-close rocket-font-helvetica">
                                  [ x ]
                            </div>
                        </div>
                        <div class="wishlist__size-heading rocket-font-helvetica">AÑADIR TALLA</div>
                    </div>
                    <variant-swiper class="wishlist-product-card__quick-add no-js-hidden" id="product-${productId}" data-product-id="">
                        <div class="variant-swiper-button variant-swiper-button-prev visually-hidden">
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.75 0.5L1.25 6L6.75 11.5" stroke="black"/>
                            </svg>
                        </div>
                        <div class="variant-swiper-button variant-swiper-button-next visually-hidden">
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.25 0.5L6.75 6L1.25 11.5" stroke="black"/>
                            </svg>
                        </div>
                        <card-variant-radios class="card-variant-container swiper-container">${swiperWrapper.outerHTML}</card-variant-radios>
                    </variant-swiper>
                    <div class="wishlist__size-guide-wrapper">
                        <div class="rocket-font-helvetica wishlist__size-guide">Guia de tallas</div>
                    </div>
        `;

  return swiperTemplate;
}

function createSwiperItem(size, productId, productUrl) {
  var option = size.option1;
  if (size.option2 && size.option1.length > size.option2.length) {
    option = size.option2;
  }
  let sliderItem = `
                <div class="swiper-slide">
                    <input type="radio" name="size" value="${option}">
                    <label class="variant-size-label" onclick="event.preventDefault();wishlistAddToCart(this);" data-product-id="${productId}" data-variant-id="${size.id}" data-product-url="${productUrl}">${option}</label>
                </div>`;

  return sliderItem;
}

function openPopup(elm) {
  let swiper = elm.parentNode.querySelector(".variant-slider");
  swiper.classList.add("open");

  document.querySelector(".wishlist__overlay").classList.add("open");
}

function closePopup(elm) {
  let wishlist = elm.closest(".wishlist-items-container");

  wishlist
    .querySelectorAll(".variant-slider")
    .forEach(function (variantPicker) {
      variantPicker.classList.remove("open");
    });

  document.querySelector(".wishlist__overlay").classList.remove("open");
}

function closePopupOverlay(elm) {
  document.querySelector(".wishlist__overlay").classList.remove("open");
}

function wishlistAddToCart(e) {
  let productId = e.getAttribute("data-product-id");
  let variantId = e.getAttribute("data-variant-id");
  let du = e.getAttribute("data-product-url");

  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.setAttribute("data-state-cart", "swym-added");

      // console.log("Successfully added product to cart.", c);
      $.notify(locales[Shopify.locale].add_to_cart.success, "success");

      fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
        .then((res) => res.text())
        .then(function (res) {
          // console.log(res);
          let refreshCart = new DOMParser()
            .parseFromString(res, "text/html")
            .querySelector("#CartDrawer").innerHTML;

          let wrapper = document.querySelector("#CartDrawer");
          wrapper.innerHTML = refreshCart;

          let cartDrawer = document.querySelector(".rocket-cart-drawer");
          cartDrawer.cartDrawerOverlayInitEvent();

          if (cartDrawer.classList.contains("is-empty")) {
            cartDrawer.classList.remove("is-empty");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    function (e) {
      if (e == "Variant is in stock") {
        $.notify(locales[Shopify.locale].add_to_cart.out_stock, "error");
      } else {
        $.notify(locales[Shopify.locale].add_to_cart.error, "error");
      }
    }
  );
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist);

const locales = {
  en: {
    add_to_list: {
      success: "Successfully added the product to the list",
      error: "Error while adding the product to the List",
    },
    remove_from_list: {
      success: "Successfully removed the product from the list",
      error: "Error while removing the product from list",
    },
    add_to_cart: {
      success: "Successfully added product to cart",
      error: "Error while adding the product to cart",
      out_stock: "Product is out of stock",
    },
  },
  es: {
    add_to_list: {
      success: "Guardado en tus favoritos",
      error: "Error al guardar en tus favoritos",
    },
    remove_from_list: {
      success: "Eliminado de tus favoritos ",
      error: "Error al eliminar el producto de tus favoritos",
    },
    add_to_cart: {
      success: "Añadido a tu cesta",
      error: "Error al añadir el artículo a tu cesta",
      out_stock: "Artículo agotado",
    },
  },
  de: {
    add_to_list: {
      success: "Das Produkt wurde erfolgreich zur Liste hinzugefügt",
      error: "Fehler beim Hinzufügen des Produkts zur Liste",
    },
    remove_from_list: {
      success: "Das Produkt wurde erfolgreich aus der Liste entfernt",
      error: "Fehler beim Entfernen des Produkts aus der Liste",
    },
    add_to_cart: {
      success: "Produkt erfolgreich in den Warenkorb gelegt",
      error: "Fehler beim Hinzufügen des Produkts zum Warenkorb",
      out_stock: "Das Produkt ist nicht vorrätig",
    },
  },
};
